define(function (require) {
    'use strict';

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: {
            name: '',
            phone: ''
        },
        search: true,
        validation: {
            name: {
                required: true
            },
            phone: {
                required: true
            }
        }
    });
});